import { Card, CardContent } from "../../client/components/ui/card";
import { CardSectionHeader } from "../../client/components/ui/card-section-header";
import AnimatedMetric from "../../client/components/AnimatedMetric";
import { useDashboardData } from "./DashboardDataContext";

export default function AvgWinLossWidget() {
  const { metrics, isDark, t } = useDashboardData();
  if (!metrics) return null;
  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.dashboard.avgWinLoss} isDark={isDark} compact />
      <CardContent className="px-4 pb-4 pt-2 flex-1 flex flex-col justify-center min-w-0">
        <div className="space-y-1">
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-xs text-muted-foreground w-12 sm:w-16 shrink-0 truncate">{t.dashboard.avgWin}</span>
            <div className="flex-1 min-w-0 bg-muted/30 rounded-full h-1.5">
              <div className="h-1.5 rounded-full bg-primary" style={{ width: `${metrics.averageWin + Math.abs(metrics.averageLoss) > 0 ? (metrics.averageWin / (metrics.averageWin + Math.abs(metrics.averageLoss))) * 100 : 50}%` }} />
            </div>
            <AnimatedMetric value={metrics.averageWin} format="currency" prefix="+" suffix="$" className="block truncate text-xs font-bold font-mono tabular-nums text-primary w-14 sm:w-16 text-right shrink-0" />
          </div>
          <div className="flex items-center gap-2 min-w-0">
            <span className="text-xs text-muted-foreground w-12 sm:w-16 shrink-0 truncate">{t.dashboard.avgLoss}</span>
            <div className="flex-1 min-w-0 bg-muted/30 rounded-full h-1.5">
              <div className="h-1.5 rounded-full bg-destructive" style={{ width: `${metrics.averageWin + Math.abs(metrics.averageLoss) > 0 ? (Math.abs(metrics.averageLoss) / (metrics.averageWin + Math.abs(metrics.averageLoss))) * 100 : 50}%` }} />
            </div>
            <AnimatedMetric value={metrics.averageLoss} format="currency" suffix="$" className="block truncate text-xs font-bold font-mono tabular-nums text-destructive w-14 sm:w-16 text-right shrink-0" />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
